import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getInvoicesList =
  (date, type, {searchBy = 'FAC', dealerId, agencyId, scope}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          // eslint-disable-next-line max-len
          'endpoint': `/invoices/list?date=${date}&type=${type}&filter=${searchBy}&dealer=${dealerId}&agency=${agencyId}&scope=${scope}`,
          'authenticated': true,
          'types': [
            ActionTypes.FETCHING_INVOICES_LIST,
            ActionTypes.FETCHED_INVOICES_LIST,
            [
              ActionTypes.FETCHED_INVOICES_LIST_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'GET',
        })
      );
    };

export const getInvoiceItem = (facId, params) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/invoices/item/${facId}${getUrlParameters(params)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_INVOICE_ITEM,
        ActionTypes.FETCHED_INVOICE_ITEM,
        [
          ActionTypes.FETCHED_INVOICE_ITEM_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getInvoiceCombos = (facId, type) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/invoices/combos/${facId}?type=${type}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_INVOICE_COMBOS,
        ActionTypes.FETCHED_INVOICE_COMBOS,
        [
          ActionTypes.FETCHED_INVOICE_COMBOS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const cleartInvoiceList = () => {
  return {
    'type': ActionTypes.CLEAR_INVOICE_LIST,
  };
};
